import React, {useState} from 'react';
import { Redirect } from 'react-router-dom';
import {
    TextInput,
    Create,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    SimpleForm
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import ContentCreate from './ContentCreate'

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

let uid = null;
const ChecklistActions = ({props}) => (
    uid = (props && props.location)?( (props.location.uid)?props.location.uid:uid):uid,
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/checklist?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'} label='Checklist'/>
    </CardActions>
);

const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {  
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
};

const ChecklistToolbar = props => (
    <Toolbar {...props} >
        
        <SaveButton
            label="save"    
            redirect={'/checklist?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
            submitOnEnter={true}
        />
    </Toolbar>
);

const GetKey=({ props }) => (
    //console.log(props.location.uid),
    uid = (props.location)?( (props.location.uid)?props.location.uid:uid):uid,
    (uid)? '': <Redirect to="/userslist" />
);




const CheckListCreate =({ classes, ...props }) => (
    
<Create 
    title='Checklist | Add' 
    {...props}  
    actions={<ChecklistActions  props={props}/>} 
    >
    <SimpleForm toolbar={<ChecklistToolbar />}>
        <GetKey props ={props} />
        <ContentCreate  uid ={props.location.uid}  />
        <TextInput source="uid" defaultValue={props.location.uid} style={{display: 'none', visibility: 'hidden'}} />
    </SimpleForm>
</Create>
);

export default withStyles(editStyles)(CheckListCreate);